import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { FaSignOutAlt, FaTachometerAlt } from 'react-icons/fa';

const Navbar = () => {
  const { home, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to={home?.role === 'admin' ? '/admin/dashboard' : '/manager/dashboard'} className="navbar-brand">
          <img src="/littleFeetlogo.webp" alt="Little Feet Homes" className="navbar-logo" />
          <h1 className="navbar-title">Little Feet Homes</h1>
        </Link>
        <div className="navbar-menu">
          {home && (
            <>
              {/* <Link to={home.role === 'admin' ? '/admin/dashboard' : '/manager/dashboard'} className="navbar-link">
                <FaTachometerAlt />
                Dashboard
              </Link> */}
              <div className="navbar-user">
                <div className="user-info">
                  <div className="user-name">{home.title}</div>
                  <div className="user-role">{home.role}</div>
                </div>
                <button onClick={handleLogout} className="btn btn-secondary btn-sm">
                  <FaSignOutAlt />
                  Logout
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
